import { delay } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class PenaltyCreateService {

  constructor(private httpClient: HttpClient) {
  }

  createPenalty(penalty) {
    return this.httpClient.post(
      `${environment.API_ENDPOINT}penalties`,
      JSON.stringify(penalty))
      .pipe(delay(environment.RESPONSE_DELAY));
  }
}
